function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { StepperNodeStatus, StepId, StepperColors } from './stepper';
import { BillingRegionDropdownComponent } from './billingRegionDropdown';
import { PurchaseBlendsConfirmation } from './purchaseBlendsConfirmation';
import { PlansList } from './plansList';
import { BillingPaymentControl } from './billingPaymentControl';
/**
 * The steps for the checkout flow.
 * Logic runs in the Wizard, as well as localization
 */ export const CheckoutSteps = [
    {
        id: StepId.SelectBillingCountry,
        color: StepperColors.Active,
        displayName: 'Billing country',
        stepStatus: StepperNodeStatus.Active,
        ariaLabel: 'Select billing country',
        componentToRender: (props)=>/*#__PURE__*/ _jsx(BillingRegionDropdownComponent, _object_spread({}, props, props.wizardProps), 'BillingRegionComponent')
    },
    {
        id: StepId.SelectPlan,
        color: StepperColors.Active,
        displayName: 'Plan',
        stepStatus: StepperNodeStatus.NotCompleted,
        ariaLabel: 'Select plan',
        componentToRender: (props)=>/*#__PURE__*/ _jsx(PlansList, _object_spread({}, props, props.wizardProps), 'PlansListComponent')
    },
    {
        id: StepId.SelectTerm,
        color: StepperColors.Active,
        displayName: 'Billing Options',
        stepStatus: StepperNodeStatus.NotCompleted,
        ariaLabel: 'Pricing and payment options',
        componentToRender: (props)=>/*#__PURE__*/ _jsx(BillingPaymentControl, _object_spread_props(_object_spread({}, props, props.wizardProps), {
                disableBackButton: props.disableBackButton,
                disableNextButton: props.disableNextButton
            }), 'BillingPaymentComponent')
    },
    {
        id: StepId.Payment,
        color: StepperColors.Active,
        displayName: 'Payment',
        stepStatus: StepperNodeStatus.NotCompleted,
        ariaLabel: 'Payment',
        componentToRender: ()=>/*#__PURE__*/ _jsx(_Fragment, {})
    },
    {
        id: StepId.ConfigureNow,
        color: StepperColors.Active,
        displayName: 'Complete purchase',
        stepStatus: StepperNodeStatus.NotCompleted,
        ariaLabel: 'Configure your purchase',
        componentToRender: (props)=>/*#__PURE__*/ _jsx(PurchaseBlendsConfirmation, _object_spread({}, props, props.wizardProps), 'ConfirmComponent')
    }
];
export const TeamsCheckoutSteps = {
    id: StepId.TeamsVirtualStep,
    color: StepperColors.Active,
    displayName: 'Complete purchase',
    stepStatus: StepperNodeStatus.NotCompleted,
    ariaLabel: 'Complete purchase'
};
